import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

const RELATED = [["/terms-and-conditions","Terms & Conditions"],["/privacy-policy","Privacy Policy"],["/shipping-policy","Shipping Policy"],["/return-refund-policy","Return & Refund Policy"]];

export default function CancellationPolicy() {
  useSEO({
    title: "Cancellation Policy — PrintMyTees",
    description: "Read the PrintMyTees Cancellation Policy covering the one-hour cancellation window, production status and refund processing.",
  });

  return (
    <main className="container-pmt py-10 sm:py-16 max-w-4xl">
      <div className="overline text-[#E34F26]">PrintMyTees</div>
      <h1 className="mt-3 font-black text-3xl sm:text-4xl md:text-5xl uppercase">Cancellation Policy</h1>
      <p className="mt-3 text-sm text-stone-600">Last updated: October 2026</p>
      <div className="mt-8 sm:mt-10 space-y-8 sm:space-y-10 text-stone-700 leading-7">
        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">1. Cancellation Window</h2>
          <p className="mt-2">Customers may request cancellation of an order by contacting PrintMyTees within 1 hour of placing the order.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">2. Before Production</h2>
          <p className="mt-2">Cancellation requests received before production or customisation begins may be considered for cancellation and refund, subject to applicable payment processing charges or other applicable costs.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">3. After Production Begins</h2>
          <p className="mt-2">Once production or customisation has started, cancellation may not be possible because the product is being prepared specifically according to the customer's requirements.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">4. Refund Processing</h2>
          <p className="mt-2">If a cancellation is approved and a refund is applicable, the refund will be processed through the applicable payment gateway or payment method.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">5. Cancellation Request Details</h2>
          <p className="mt-2">To request cancellation, provide the order number and contact details so the request can be reviewed against the order and its production status.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">6. Review of Requests</h2>
          <p className="mt-2">PrintMyTees reviews cancellation requests based on the production status and specific circumstances of each order.</p>
        </section>
      </div>
      <div className="mt-10 sm:mt-12 border border-[#E6DFD5] bg-[#F3EDE2] p-5 sm:p-6">
        <div className="overline">Related Policies</div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RELATED.map(([to,label]) => (
            <Link key={to} to={to} className="btn-outline-pmt text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">{label}</Link>
          ))}
        </div>
      </div>
      <Link to="/" className="inline-block mt-8 sm:mt-10 btn-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">Back to Home</Link>
    </main>
  );
}
